module.exports = __webpack_public_path__ + "static/media/filter.06eac254.svg";